import { Box, Flex, Text, Divider, Image } from "@chakra-ui/react";
import Link from "next/link";
import { useRouter } from "next/router";
import dayjs from "dayjs";

const ArticlePreviewList = ({
  image,
  title,
  author,
  slug,
  summary,
  date,
  storyblokImage,
}) => {
  const router = useRouter();
  let formattedDate;
  if (date) {
    formattedDate = dayjs(date).format("D MMM, YYYY");
  }
  return (
    <Link href={`/article/${slug}`} prefetch={false}>
      <Box mt="40px" cursor="pointer">
        <Flex
          width="100%"
          justify="space-between"
          columnGap="20px"
          align={{ base: "center", xl: "flex-start" }}
        >
          <Flex direction="column" rowGap="10px">
            <Text textStyle="h5bold" color="brand.200">
              {author}
              {formattedDate && (
                <span style={{ fontWeight: "500" }}> · {formattedDate}</span>
              )}
            </Text>
            <Text textStyle="h3">{title}</Text>
            {summary && (
              <Text display={{ base: "none", xl: "block" }}>{summary}</Text>
            )}
          </Flex>
          {(image || storyblokImage) && (
            <Image
              width={{ base: "80px", xl: "215px" }}
              minW={{ base: "80px", xl: "215px" }}
              height={{ base: "80px", xl: "140px" }}
              borderRadius="5px"
              position="relative"
              alt={title}
              objectFit="cover"
              layout="fill"
              src={storyblokImage?.filename || image}
              placeholder="blur"
            />
          )}
        </Flex>
        <Divider borderWidth="1px" mt="40px" />
      </Box>
    </Link>
  );
};

export default ArticlePreviewList;
